import { render, staticRenderFns } from "./Wmts.vue?vue&type=template&id=37ef024e&scoped=true"
import script from "./Wmts.vue?vue&type=script&lang=js"
export * from "./Wmts.vue?vue&type=script&lang=js"
import style0 from "./Wmts.vue?vue&type=style&index=0&id=37ef024e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37ef024e",
  null
  
)

export default component.exports